document.addEventListener('alpine:init', () => {
  Alpine.store('cart_count', {
    count: (window.theme && window.theme.cartItemCount) || 0,
    init() {
      const update = (event) => ThemeCart.renderEvent(event, (snapshot) => {
        this.count = snapshot.count;
      }, 'count');
      window.addEventListener('shapes:modalcart:afteradditem', update);
      window.addEventListener('shapes:modalcart:cartqtychange', update);
    },
    countWithText() {
      return (this.count === 1 ? theme.strings.itemCountOne : theme.strings.itemCountOther)
        .replace('{{ count }}', this.count);
    },
  });
});
